import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {OptionCardComponent} from '../option-card/option-card.component';
import {OptionItem, OptionLayout} from '../option-card/option-card.model';

@Component({
    selector: 'app-option-select',
    standalone: true,
    imports: [TranslatePipe, OptionCardComponent],
    template: `
        <div
            class="option-list d-flex"
            [class.flex-column]="layout() === 'stacked'"
            [class.row-layout]="layout() === 'row'"
            role="radiogroup"
            [attr.aria-label]="ariaKey() | translate: 'online' : 'export'">
            @for (option of options(); track option.id) {
                <app-option-card
                    class="option-item d-flex"
                    [name]="name()"
                    [item]="option"
                    [selected]="selectedId() === option.id"
                    (optionSelected)="optionSelected.emit(option.id)" />
            }
        </div>
    `,
    styles: `
        .option-list {
            border: var(--option-list-border, 1px solid rgba(var(--bs-primary-rgb), 0.3));
        }

        .option-item + .option-item {
            border-top: 1px solid rgba(var(--bs-primary-rgb), 0.15);
        }

        .option-list.row-layout .option-item {
            flex: 1 1 0;

            & + .option-item {
                border-top: 0;
                border-left: 1px solid rgba(var(--bs-primary-rgb), 0.15);
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionSelectComponent {
    readonly options = input.required<ReadonlyArray<OptionItem>>();
    readonly selectedId = input.required<string>();
    readonly name = input.required<string>();
    readonly ariaKey = input.required<string>();
    readonly layout = input<OptionLayout>('stacked');

    readonly optionSelected = output<string>();
}
